import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import {
  ADMIN_DELIVERY_PRODUCT_CATEGORY_DETAIL_QUERY,
  ADMIN_DELIVERY_PRODUCT_CATEGORY_LIST_QUERY,
} from "../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const baseUrl = "/deliveryProducts/categories";

  const { data, loading, error } = useQuery(
    ADMIN_DELIVERY_PRODUCT_CATEGORY_DETAIL_QUERY,
    {
      variables: { id: match.params.id },
    }
  );

  if (error) {
    return <>{error.message}</>;
  }
  if (loading) {
    return <></>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
